import { composeRewrites } from "@tanstack/react-router";
import { rewriteLegacyJobPostingPath } from "./lib/job-posting-routing";

export const legacyJobPostingRewrite = {
  input: ({ url }: { url: URL }) => {
    const rewrittenPath = rewriteLegacyJobPostingPath(url.pathname);

    if (!rewrittenPath) {
      return undefined;
    }

    url.pathname = rewrittenPath;

    return url;
  },
};

export const routerRewrites = [legacyJobPostingRewrite];

export const appRewrite = composeRewrites(routerRewrites);
